<div id="am-container-custom">
<!-- Flag for care -->
<app-header *ngIf="!enableAhubFlow && !isRunningInGlobalNav"></app-header>
<router-outlet *ngIf="!enableAhubFlow  && !isRunningInGlobalNav"></router-outlet>
<app-loader></app-loader>

<!-- Flag for AHUB -->
<router-outlet *ngIf="enableAhubFlow && path==='/apps/tfb_acctmgmt/account-management/logout' && !isRunningInGlobalNav"></router-outlet>
<app-footer *ngIf="enableAhubFlow && !isRunningInGlobalNav"></app-footer>


<div *ngIf="isBannerVisible" class="ahub_banner">
    <div class="row banner_container">
      <div class="col-md-11 col-xs-11">
        <div class="row">
          <div class="col-md-11 col-xs-10 banner_text_div" [ngClass]="">
            <span class="green green-check-circle banner-text-green">
              <strong>Your two-factor authentication is complete.</strong><br/>
            Please select an action you would like to take.</span>
          </div>
        </div>
      </div>
    </div>
</div>

<div *ngIf="isMultiBannerVisible" class="ahub_banner_multi">
  <div class="row banner_container">
    <div class="col-md-11 col-xs-11">
      <div class="row">
        <button type="button" class="text_right_clone" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="col-md-9 banner_text_div_center" [ngClass]="">
          <span class="icon-warning">
            <div class="main_text_div">
              <strong>Over Line Count</strong>
            </div>
          </span>   
          <div> You can only perform this action on only up to 12 lines at a time.</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ahub_banner_multi" *ngIf="isRestrictionBannerVisible" >
  <div class="row banner_container">
    <div class="col-md-11 col-xs-11">
      <div class="row">
        <button type="button" class="text_right_clone" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>  
        <div class="col-md-9 banner_text_div_center" [ngClass]="">
          <span class="icon-warning">
            <div class="main_text_div">
              <strong>Restricted access</strong>
            </div>
          </span>   
          <div> SIM Protection is on and you don't have permission to turn it off. Please contact your team admin.</div>
        </div>  
      </div>
    </div>
  </div>
</div>

<div *ngIf="isFailureBannerVisible" class="ahub_banner_failure">
  <div class="row banner_container">
    <div class="col-md-11 col-xs-11">
      <div class="row">
        <div class="col-md-12 banner_text_div" [ngClass]="">
          <span class="icon-failure">
            <div class="main_text_div">
              <strong>Two-factor authentication failed</strong><br />
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet *ngIf="isRunningInGlobalNav"></router-outlet>
</div>
